<template>
  <el-dialog 
    :title="$t('dictManage.editDict')" 
    :visible.sync="dialogVisible"
    width="50%"
  >
    <el-form 
      ref="form" 
      :model="editDictInfo" 
      label-width="100px"
      :rules="rules"
    >
      <el-form-item 
        :label="$t('dictManage.name')" 
        prop="name"
      >
        <el-input 
          v-model="editDictInfo.name" 
          :placeholder="$t('dictManage.inputNameRequired')"
        />
      </el-form-item>
      <el-form-item 
        :label="$t('dictManage.value')" 
        prop="statusCd"
      >
        <el-input 
          v-model="editDictInfo.statusCd" 
          :placeholder="$t('dictManage.inputValueRequired')"
        />
      </el-form-item>
      <el-form-item 
        :label="$t('dictManage.description')" 
        prop="description"
      >
        <el-input 
          v-model="editDictInfo.description" 
          :placeholder="$t('dictManage.inputDescRequired')"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button 
        type="primary" 
        @click="editDict"
      >
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateDict } from '@/api/dev/dictApi'

export default {
  name: 'EditDict',
  data() {
    return {
      dialogVisible: false,
      editDictInfo: {
        id: '',
        name: '',
        statusCd: '',
        description: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('dictManage.nameRequired'), trigger: 'blur' },
          { max: 50, message: this.$t('dictManage.nameMaxLength'), trigger: 'blur' }
        ],
        statusCd: [
          { required: true, message: this.$t('dictManage.valueRequired'), trigger: 'blur' },
          { max: 64, message: this.$t('dictManage.valueMaxLength'), trigger: 'blur' }
        ],
        description: [
          { required: true, message: this.$t('dictManage.descRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('dictManage.descMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
        this.editDictInfo = { ...row }
      })
    },
    async editDict() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        
        try {
          await updateDict(this.editDictInfo)
          this.$message.success(this.$t('dictManage.editSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        } catch (error) {
          console.error('修改字典失败:', error)
        }
      })
    }
  }
}
</script>